declare global {
	interface Window {
		ACCESS_TOKEN?: string;
		js_config: {
			page_to_load: string;
			locale: string;
			API_BASE_URL: string;
			cb_site: string;
			cb_key: string;
			access_token?: string;
			bugsnag?: {
				apiKey: string;
				releaseStage: string;
			};
		};
		__INITIAL_DATA__: object;
	}
}

export function getAppConfig(): Window['js_config'] | undefined {
	if (typeof window !== 'undefined') {
		return window.js_config;
	}
	return undefined;
}
